export const checkHasWalmartRecipient = (
  recipientGLNs = [],
  walmartRecipientList = []
) => {
  const recipientGlns = recipientGLNs?.map((item) => item.partyGln);
  return recipientGlns?.some((recipientGln) =>
    walmartRecipientList?.some(
      (walmartParty) => walmartParty.partyGln === recipientGln
    )
  );
};

export const mapToPublishProductCheckListRequest = ({
  products,
  recipientGLNs,
  formValues,
  productFull,
  isFullView,
}) => {
  const productIds = products.map((items) => items.id);
  const recipientIds = recipientGLNs?.map((items) => items.partyGln);

  let params = {
    ...formValues,
    productIds: isFullView ? [productFull?.productId] : productIds,
    recipientGLNs: recipientIds,
  };

  return params;
};
